import script from "./general-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./general-settings.vue?vue&type=script&setup=true&lang=ts"

import "./general-settings.vue?vue&type=style&index=0&id=bbd733cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbd733cc"]])

export default __exports__